import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import AuthLayout from '@dashboard/layouts/AuthLayout';

import Link from '@dashboard/components/Link';
import { FormElement, FormSubmit, Label, TextInput } from '@dashboard/components/Form';
import { FormErrorBase } from '@dashboard/components/Formik/components/FormError';
import Meta from '@dashboard/components/Meta';

const propTypes = {
  form: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const AccountResetPassword = props => {
  const { form, handleSubmit, handleInputChange } = props;

  return (
    <>
      <Meta
        meta={{
          title: 'Reset your password',
        }}
      />

      <AuthLayout>
        <div className="text-center">
          <h1 className="text-4xl">Reset your password</h1>
          <h3 className="text-lg mt-2 font-normal mb-4">Add a new password below</h3>
        </div>

        <form onSubmit={e => handleSubmit(e)}>
          <FormElement>
            <Label htmlFor="password">Password</Label>
            <TextInput
              id="password"
              name="password"
              type="password"
              border
              placeholder="Your new password"
              value={form.state.password}
              onChange={e => handleInputChange(e)}
              required
            />
          </FormElement>

          {form.message && (
            <FormElement>
              <FormErrorBase>{form.message}</FormErrorBase>
            </FormElement>
          )}

          <FormElement>
            <FormSubmit>
              <FormSubmit.Button size="full">Save</FormSubmit.Button>
            </FormSubmit>
          </FormElement>
        </form>

        {form.saved && !form.message && (
          <FormElement>
            Your password has been reset. You can now{' '}
            <Link href="/login" className="inline-flex gap-x-1 items-center">
              log in <ArrowRightIcon className="w-4 h-4" />{' '}
            </Link>
          </FormElement>
        )}
      </AuthLayout>
    </>
  );
};

AccountResetPassword.propTypes = propTypes;

export default AccountResetPassword;
